import { useTranslation } from 'react-i18next';
import ErrorImage from '@/assets/images/error.svg';
import { AnchorButton, LinkButton } from '@/components/buttons';
import { routeMap } from '@/routes/routeMap';

type Props = {
  browserNavigationEnabled?: boolean;
};

function ErrorInfo({ browserNavigationEnabled = false }: Props) {
  const { t } = useTranslation('ErrorInfo');

  return (
    <>
      <div className="flex flex-col gap-6 pt-6">
        <div className="flex flex-col gap-4">
          <h1 className="text-heading">{t('title')}</h1>
          <p>{t('text')}</p>
        </div>
        <img src={ErrorImage} alt="" />
      </div>
      <div className="mt-auto">
        {/* When the ErrorBoundary triggers, react router navigation is disabled. To fix that, we
        need to navigate through the browser */}
        {browserNavigationEnabled ? (
          <AnchorButton href={routeMap.home}>{t('button')}</AnchorButton>
        ) : (
          <LinkButton replace to={routeMap.home}>
            {t('button')}
          </LinkButton>
        )}
      </div>
    </>
  );
}

export default ErrorInfo;
